import { render, staticRenderFns } from "./ManagedListRelatedTabs.vue?vue&type=template&id=45c9e8a0"
import script from "./ManagedListRelatedTabs.vue?vue&type=script&lang=js"
export * from "./ManagedListRelatedTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports